'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Message = function (_PureComponent) {
  _inherits(Message, _PureComponent);

  function Message() {
    _classCallCheck(this, Message);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  Message.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        children = _props.children,
        className = _props.className;


    if (!children) {
      return null;
    }

    return _react2.default.createElement(
      'div',
      {
        'aria-hidden': !active,
        className: (0, _classnames2.default)('md-text-field-message', 'md-text-field-message--' + (active ? '' : 'in') + 'active', className)
      },
      children
    );
  };

  return Message;
}(_react.PureComponent);

Message.propTypes = {
  active: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  children: _propTypes2.default.node
};
exports.default = Message;


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/TextFields/Message.js
// module id = 912
// module chunks = 213534597649335